module.exports = __webpack_public_path__ + "img/shutterstock_587205803.a18fe0c9.jpg";